import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import SearchIcon from "@mui/icons-material/Search";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import 'bootstrap/dist/css/bootstrap.css';
import ProfileImage from "../../assets/images/profile.jpg"
import Dropdown from 'react-bootstrap/Dropdown';
import "./style.css";
import { useLocation, withRouter, useHistory } from 'react-router-dom';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import {
  Avatar,
  Collapse,
} from "@mui/material";
import ChevronRight from "@mui/icons-material/ChevronRight";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { Grid } from "@mui/material";
import Logo from "../../assets/images/jm_logo.png";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import PeopleIcon from '@mui/icons-material/People';
import BadgeIcon from '@mui/icons-material/Badge';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import SecurityIcon from '@mui/icons-material/Security';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ApartmentIcon from "@mui/icons-material/Apartment";
import PaidIcon from "@mui/icons-material/Paid";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import SystemSecurityUpdateGoodIcon from "@mui/icons-material/SystemSecurityUpdateGood";
import LanguageIcon from "@mui/icons-material/Language";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import "../Sidebar/style.css";
import { Link } from 'react-router-dom';
import { Badge } from "reactstrap";
import NotificationDrawer from "../Notification/Notification";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import {AssignmentOutlined, AvTimerSharp} from "@material-ui/icons";
import FactCheckIcon from '@mui/icons-material/FactCheck';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { hasPermission, canAssignStaff } from "../../utils/commonutils";
import { Chat } from "@mui/icons-material";
import { connect } from "react-redux";
import { fetchRolePermissions } from "../../redux/actions/RoleActions";
import Cookies from "js-cookie";

const drawerWidth = 240;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  [theme.breakpoints.down("md")]: {
    display: "block",
    position: "fixed",
    zIndex: "99999999",
    width: "40vw",
  },
  [theme.breakpoints.down("sm")]: {
    width: "80vw",
  },
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
});
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open
    ? {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      [theme.breakpoints.down("md")]: {
        width: "100% ",
      },
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }
    : {
      width: `calc(100% - ${theme.spacing(8)} + 8px)`,
      [theme.breakpoints.down("md")]: {
        width: "100% ",
      },
    }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));


function Sidebar({ children, collapsed, setCollapsed, authData }) {
  // Page title follows the current module so staff always know where they are.
  const theme = useTheme();
  const [dropDown, setdropDown] = React.useState(false);
  const [dropDown_two, setdropDown_two] = React.useState(false);
  const [dropDown_three, setdropDown_three] = React.useState(false);
  const [dropDown_four, setdropDown_four] = React.useState(false);
  const [open,setOpen]=React.useState(false)
  const handleDrawerOpen = () => {
    setCollapsed(true);
  };

  const location = useLocation();
  const pathname = location.pathname;
  console.log(pathname, "Pathname")
  const appbarTitle = () => {
    if (pathname === "/customers") {
      return "Customers"
    }
    else if (pathname === "/employees") {
      return "Employees"
    }
    else if (pathname === "/dashboard") {
      return "Dashboard"
    }
    else if (pathname === "/tasks") {
      return "Task"
    }
    else if (pathname === "/roles") {
      return "Roles"
    }
    else if (pathname === "/masters") {
      return "Masters"
    }
    else if (pathname === "/follow-up") {
      return "Follow-up"
    }
     else if (pathname === "/document") {
      return "Documents"
    }
      else if (pathname === "/communication") {
      return "Communications"
    }
      else if (pathname === "/auditreport") {
      return "Audit Report"
    }
     else if (pathname  === "/casemanagement"){
      return "GST cases"
     }
      else if (pathname  === "/payment"){
      return "Payment Recovery"
     }
     else if (pathname === "/inquiary" || pathname.startsWith("/inquiriedetail")) {
      return "Inquiry Management"
     }
     else if (pathname.startsWith("/employees")) {
      return "Employees"
     }
     else if (pathname.startsWith("/customers")) {
      return "Customers"
     }
     return "JM Associates"
  }

  const handleDrawerClose = () => {
    setCollapsed(false);
    setdropDown(false);
    setdropDown_two(false);
    setdropDown_three(false);
    setdropDown_four(false);
  };

  const toggledropDown = (value) => {
    if (value === "dropDown") {
      setdropDown(!dropDown);
      setdropDown_two(false);
      setdropDown_three(false);
      setdropDown_four(false);
    } else if (value === "dropDown_two") {
      setdropDown_two(!dropDown_two);
      setdropDown(false);
      setdropDown_three(false);
      setdropDown_four(false);
    } else if (value === "dropDown_three") {
      setdropDown_three(!dropDown_three);
      setdropDown(false);
      setdropDown_two(false);
      setdropDown_four(false);
    } else if (value === "dropDown_four") {
      setdropDown_four(!dropDown_four);
      setdropDown(false);
      setdropDown_two(false);
      setdropDown_three(false);
    }
  }
  const history = useHistory()
  const [, setMenuTick] = React.useState(0);

  React.useEffect(() => {
    const token = authData?.accessToken || Cookies.get("ClaccessToken");
    const role = authData?.role || Cookies.get("Clrole");
    if (!token || !role) return undefined;
    fetchRolePermissions(token, role)
      .then(() => setMenuTick((n) => n + 1))
      .catch(() => undefined);
  }, [authData?.accessToken, authData?.role]);
  const handleprofile = ()=>{
      history.push('/profile')
  }
  const handleLogout = () => {

    var cookies = document.cookie.split(";");
    console.log('cookies', cookies);
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      console.log("cookie deleted")
    }

    console.log('logout clicked');
    console.log('logout cookie', document.cookie);
    history.push('/login')
  }

 const sidebarGroups = [
  {
    title: "Overview",
    items: [{ label: "Dashboard", path: "/dashboard", icon: <HomeIcon htmlColor="#d7e2f4" style={{ fontSize: 20 }} /> }],
  },
  {
    title: "Sales",
    items: [
      { label: "Inquiry", path: "/inquiary", icon: <Chat htmlColor="#d7e2f4" style={{ fontSize: 20 }} />, permission: "read_inquiry" },
      { label: "Follow-ups", path: "/follow-up", icon: <AssignmentTurnedInIcon htmlColor="#d7e2f4" style={{ fontSize: 20 }} />, permission: "read_followup" },
      { label: "Customers", path: "/customers", icon: <PeopleIcon htmlColor="#d7e2f4" style={{ fontSize: 20 }} />, permission: "read_customers" },
      { label: "Communication", path: "/communication", icon: <ForumOutlinedIcon htmlColor="#d7e2f4" style={{ fontSize: 20 }} />, permission: "read_communication" },
    ],
  },
  {
    title: "Work",
    items: [
      { label: "Tasks", path: "/tasks", icon: <ViewKanbanIcon htmlColor="#d7e2f4" style={{ fontSize: 20 }} />, permission: "read_task" },
      { label: "Payment recovery", path: "/payment", icon: <AccountBalanceIcon htmlColor="#d7e2f4" style={{ fontSize: 20 }} />, permission: "read_paymentrecovery" },
      { label: "GST cases", path: "/casemanagement", icon: <FactCheckIcon htmlColor="#d7e2f4" style={{ fontSize: 20 }} />, permission: "read_casemanagement" },
      { label: "Documents", path: "/document", icon: <InsertDriveFileIcon htmlColor="#d7e2f4" style={{ fontSize: 20 }} />, permission: "read_document" },
      { label: "Audit report", path: "/auditreport", icon: <AssignmentOutlined htmlColor="#d7e2f4" style={{ fontSize: 20 }} />, permission: "read_audit_report" },
    ],
  },
  {
    title: "Team",
    items: [
      { label: "Employees", path: "/employees", icon: <BadgeIcon htmlColor="#d7e2f4" style={{ fontSize: 20 }} />, permission: "read_employee" },
      { label: "Roles", path: "/roles", icon: <SecurityIcon htmlColor="#d7e2f4" style={{ fontSize: 20 }} />, permission: "read_role" },
      { label: "Masters", path: "/masters", icon: <ListAltIcon htmlColor="#d7e2f4" style={{ fontSize: 20 }} />, anyOf: ["read_master", "read_role"], leadOnly: true },
    ],
  },
];
  return (
    <Grid container className="sidebar-main">
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <div>
          <Box sx={{ display: "flex" }} className="demo_class">
            <CssBaseline />
            {/* Appbar Content */}
            <AppBar className="appbarmain" position="fixed" open={collapsed}>
              <Toolbar style={{ alignItems: "center" }}>
                <Grid container style={{ alignItems: "center" }}>
                  <Grid item lg={6} sm={8} md={4} xs={8}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={collapsed ? handleDrawerClose : handleDrawerOpen}
                        edge="start"
                        sx={{}}
                        style={{ color: "var(--thm-color)" }}
                      >
                        {collapsed ? (
                          <ChevronLeftIcon
                            style={{ color: "var(--thm-color)" }}
                          />
                        ) : (
                          <MenuIcon className="" />
                        )}
                      </IconButton>
                      <Typography
                        className="appbarTitle "
                        variant="h5"
                        component="h2"
                      >
                        {appbarTitle()}
                      </Typography>
                    </div>
                  </Grid>
                  <Grid item lg={6} sm={4} md={8} xs={4}>
                    <div className="appbar-right-side-icons">
                      <Box
                        sx={{
                          display: {
                            xs: "block  !important ",
                            sm: "block !important",
                            md: "none !important",
                            lg: "none !important",
                          },
                        }}
                      >
                        <IconButton
                          size="large"
                          aria-label="show 4 new mails"
                          color="inherit"
                        >
                          <SearchIcon className="gray-icon" />
                        </IconButton>
                      </Box>                    
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div className="profile-dropdown">
                          <Dropdown className="dropdown-main">
                              <Dropdown.Toggle variant="success">
                                <div className="user-chip">
                                  <Avatar sx={{ width: 34, height: 34, bgcolor: "#1a3366", fontSize: 14 }}>
                                    {(authData?.firstName || authData?.name || "U").charAt(0).toUpperCase()}
                                  </Avatar>
                                  <div className="user-chip-meta">
                                    <span className="user-chip-name">{authData?.firstName || authData?.name || "User"}</span>
                                    <span className="user-chip-role">{authData?.role || "staff"}</span>
                                  </div>
                                </div>
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item href="#" onClick={handleprofile}>
                                  Profile
                                </Dropdown.Item>
                                <Dropdown.Item href="#" onClick={handleLogout}>
                                  Logout
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Toolbar>
            </AppBar>
            <Drawer className="drawerMain" variant="permanent" open={collapsed}>
              <DrawerHeader className="drawerheader">
                {collapsed ? (
                  <div className="brand-block">
                    <img src={Logo} alt="" className="logo" />
                    <div>
                      <div className="brand-name">JM Associates</div>
                      <div className="brand-sub">Workspace</div>
                    </div>
                  </div>
                ) : (
                  <img src={Logo} alt="" className="logo_close" />
                )}
                <IconButton
                  sx={{
                    display: {
                      xs: "block ",
                      sm: "block",
                      md: "none !important",
                      lg: "none !important",
                    },
                  }}
                  onClick={handleDrawerClose}
                >
                  {theme.direction === "rtl" ? (
                    <HighlightOffIcon />
                  ) : (
                    <HighlightOffIcon style={{ fontSize: "40px" }} />
                  )}
                </IconButton>
              </DrawerHeader>
        {sidebarGroups.map((group) => {
          const visible = group.items.filter((item) => {
            if (item.leadOnly && canAssignStaff(authData?.role)) return true;
            if (item.anyOf?.length) return item.anyOf.some((op) => hasPermission(op));
            return !item.permission || hasPermission(item.permission);
          });
          if (!visible.length) return null;
          return (
            <div key={group.title} className="nav-group">
              {collapsed && <div className="nav-group-title">{group.title}</div>}
              {visible.map((item) => {
                const isActive =
                  item.path === "/inquiary"
                    ? pathname.includes("inqui")
                    : pathname === item.path || pathname.startsWith(`${item.path}/`);
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`nav-link ${isActive ? "nav-item-active" : ""}`}
                  >
                    <span className="nav-icon-wrap" aria-hidden>
                      {item.icon}
                    </span>
                    <span className="nav-label">{item.label}</span>
                  </Link>
                );
              })}
            </div>
          );
        })}

        <button type="button" className="sidebar-collapse" onClick={collapsed ? handleDrawerClose : handleDrawerOpen}>
          {collapsed ? "Collapse" : ""}
        </button>
            </Drawer>
            <div
              component="main"
              sx={{
                flexGrow: 1,
                p: 3 
              }}
              style={{
                width: "100%",
              }}
              className={`app-content ${collapsed === true ? "collapsed-open" : "collapsed-close"}`}
            >
              <DrawerHeader />
              {children}
            </div>
          </Box>
        </div>
      </Grid>
    </Grid >
  );
}

export default withRouter(connect((state) => ({ authData: state.authReducer }))(Sidebar))